var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaidDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9995 4V12H59.9995V4H67.9995V12H83.9995C85.0604 12 86.0778 12.4214 86.8279 13.1716C87.5781 13.9217 87.9995 14.9391 87.9995 16V80C87.9995 81.0609 87.5781 82.0783 86.8279 82.8284C86.0778 83.5786 85.0604 84 83.9995 84H11.9995C10.9386 84 9.92123 83.5786 9.17108 82.8284C8.42094 82.0783 7.99951 81.0609 7.99951 80V16C7.99951 14.9391 8.42094 13.9217 9.17108 13.1716C9.92123 12.4214 10.9386 12 11.9995 12H27.9995V4H35.9995ZM79.9995 40H15.9995V76H79.9995V40ZM60.1435 44.544L65.7995 50.2L45.9995 70L31.8555 55.856L37.5195 50.2L46.0035 58.688L60.1475 44.544H60.1435ZM27.9995 20H15.9995V32H79.9995V20H67.9995V24H59.9995V20H35.9995V24H27.9995V20Z",
    fill: "#242423",
    fillOpacity: 0.16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidDate);
export default __webpack_public_path__ + "static/media/paid-date.995b1370b433b8c51a8d56d107968c43.svg";
export { ForwardRef as ReactComponent };